import React from "react";
import Navbar from "../../components/navbar/navbar";
import job_interview from '../../assets/images/job_interview.png';
import { Link } from "react-router-dom";
import icon1 from './service_icons/icon1.png'
import icon2 from './service_icons/icon2.png'
import icon3 from './service_icons/icon3.png'
import icon4 from './service_icons/icon4.png'
function DueDeligence(){
    return(
        <>
        <Navbar/>
        <div data-aos="fade-in">
        <div className="services_banner services_banner3">
            <div>
                <h2>Research & Due Diligence</h2>
                <p>
                    At Buyers Galaxy, we understand that buying a property is a significant investment, 
                    and you need to be confident that every decision is backed by thorough research and careful 
                    evaluation. Our Due Diligence and Research Services are designed to provide you with a clear 
                    understanding of the property’s true value and potential, ensuring that you make informed, 
                    strategic decisions without any surprises.
                </p>
                <Link to="/contact" className="btn">Contact Us</Link>
            </div>
        </div>
        <div className="service_offer">
            <h2 className="offer">What We Offer</h2>
            <div className="offer_blocks">
                <div className="service_box">
                    <div className="service_icon">
                        <img src={icon1} alt="" />
                    </div>
                    <div>
                        <h5>Comprehensive Market Research</h5>
                        <p>We analyze market trends, sales, and property values, ensuring informed decisions with accurate, up-to-date insights.</p>
                    </div>
                    <Link to="/contact">Get Started</Link>
                </div>
                <div className="service_box">
                    <div className="service_icon">
                        <img src={icon2} alt="" />
                    </div>
                    <div>
                        <h5>Risk Assessment</h5>
                        <p>We assess factors like developments, infrastructure, and market changes to safeguard your investment strategy.</p>
                    </div>
                    <Link to="/contact">Get Started</Link>
                </div>
                <div className="service_box">
                    <div className="service_icon">
                        <img src={icon3} alt="" />
                    </div>
                    <div>
                        <h5>Vendor Motivations</h5>
                        <p>We understand how vendors think and what drives their decisions. With this insight, we help you understand the vendor’s position, which can give you the upper hand in negotiations.</p>
                    </div>
                    <Link to="/contact">Get Started</Link>
                </div>
                <div className="service_box">
                    <div className="service_icon">
                        <img src={icon4} alt="" />
                    </div>
                    <div>
                        <h5>Strategic Insights</h5>
                        <p>Our research evaluates a property's potential for capital growth or rental yield, ensuring a strong long-term investment.</p>
                    </div>
                    <Link to="/contact">Get Started</Link>
                </div>
            </div>
        </div>
        <div className="services_info_bottom">
            <p>Discover Melbourne's no-go suburbs for Investment</p>
            <Link to='/download'>Download Now</Link>
        </div>
        <div className="services_info">
            <div className="service_img_detail">
                <h2>Why Choose Us?</h2>
                <p>
                    At Buyers Galaxy, our expert knowledge and years of real estate experience provide 
                    you with reliable data and insights to guide your decisions. With a proven track 
                    record of helping buyers avoid pitfalls and identifying critical issues others may 
                    miss, we ensure every detail is carefully checked. Our objective and detached analysis 
                    focuses solely on protecting your financial interests, allowing you to make the best 
                    decision for your future. By simplifying the process through thorough due diligence 
                    and research, we provide the clarity, confidence, and peace of mind you need to navigate 
                    the property market with ease, ensuring your investment is sound and stress-free.
                </p>
                {/* <Link to="/contact" className="con-btn">Get a House Now</Link> */}
            </div>
            <img src={job_interview} alt="" />
        </div>
        <div className="services_details"></div>
        </div>
        </>
    );

}
export default DueDeligence;